import React from "react";
import { motion } from "framer-motion";
import { FaPlay } from "react-icons/fa";
import videoBg from "../../assets/villas-images/Aerial-View.jpg";

export default function VideoTourVillas() {
  const videoUrl = "https://youtu.be/XDQSq_Fkgyk?si=4Q-5yxua-fPvM_Rr";

  return (
    <section className="villas-video-section text-center" id="villas-video-tour">
      <div className="container">
        {/* Section Header */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8">
            <span className="villas-video-kicker">Refined Gated Living</span>
            <h2 className="villas-video-title">Virtual Video Tour</h2>
            <div className="villas-video-title-line mx-auto mt-3 mb-4"></div>
            <p className="villas-video-desc text-muted">
              Step inside Vessella Villas. Experience a signature walkthrough of our premium gated villa enclave, showcasing exquisite modern spaces, grand architecture, lush manicured parks, and elite clubhouse amenities.
            </p>
          </div>
        </div>

        {/* Premium Animated Play Card */}
        <div className="row justify-content-center mb-2">
          <div className="col-lg-10">
            <a 
              href={videoUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="d-block"
              style={{ textDecoration: "none" }}
            >
              <motion.div 
                className="villas-video-wrapper position-relative overflow-hidden shadow-lg"
                whileHover={{ scale: 1.012 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              >
                <img 
                  src={videoBg} 
                  alt="Vessella Villas Video Tour Preview" 
                  className="villas-video-thumbnail w-100 h-100"
                />
                <div className="villas-video-overlay position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center">
                  <motion.div 
                    className="villas-video-play-btn d-flex align-items-center justify-content-center border-0"
                    whileHover={{ scale: 1.15 }}
                    whileTap={{ scale: 0.95 }}
                    aria-label="Play video tour"
                  >
                    <FaPlay className="play-icon text-white ms-1" size={24} />
                    <span className="play-ripple ripple-1"></span>
                    <span className="play-ripple ripple-2"></span>
                  </motion.div>
                  <span className="villas-video-play-text mt-4 text-white text-uppercase tracking-wider">Watch Video Tour</span>
                </div>
              </motion.div>
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
